"use client";

import { Button } from "@papier/ui/components/ui/button";
import { Card, CardContent } from "@papier/ui/components/ui/card";
import { Label } from "@papier/ui/components/ui/label";
import { Trash2 } from "lucide-react";
import { SchemaField } from "@papier/grapesjs-editor/src/components/editor/schema-builder/types/schema";
import { getDefaultExampleForType } from "@/utils/schema-utils";
import { PrimitiveExampleEditor } from "./primitive-example-editor";

interface ObjectExampleEditorProps {
  example: any;
  objectField: SchemaField;
  onUpdate: (value: any) => void;
  onRemove: () => void;
  compact?: boolean;
}

export function ObjectExampleEditor({
  example,
  objectField,
  onUpdate,
  onRemove,
}: ObjectExampleEditorProps) {
  const updateProperty = (propertyName: string, value: any) => {
    onUpdate({ ...example, [propertyName]: value });
  };

  return (
    <Card>
      <CardContent className="space-y-2 p-3">
        <div className="flex items-center justify-between">
          <Label className="text-sm font-medium">Object Example</Label>
          <Button variant="outline" size="sm" onClick={onRemove}>
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
        {objectField.objectFields?.map((field) => (
          <div key={field.id} className="space-y-1">
            <Label className="text-muted-foreground text-xs">{field.name}</Label>
            <PrimitiveExampleEditor
              example={example[field.name] || getDefaultExampleForType(field.type, field)}
              field={field}
              onUpdate={(value) => updateProperty(field.name, value)}
              onRemove={() => {
                const newExample = { ...example };
                delete newExample[field.name];
                onUpdate(newExample);
              }}
            />
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
